import { render, staticRenderFns } from "./SkeletonMenuCategory.vue?vue&type=template&id=4644042e&"
import script from "./SkeletonMenuCategory.vue?vue&type=script&lang=js&"
export * from "./SkeletonMenuCategory.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonMenuCategory.vue?vue&type=style&index=0&id=4644042e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports